import React from 'react'
import BannerImage from "../assets/BannerImage.jpg";
import ServiceComponent from '../Components/ServiceComponent'
import GetInTouch from '../Components/GetInTouch'
import Stats from '../Components/Stats'

const Services = () => {
  return (
    <>
        <div className='relative -z-50'>
            <div className="absolute w-full h-[300px]">
                <img src={BannerImage} alt="WhyChooseUs" className="object-cover w-full h-[300px] opacity-95" />
            </div>
            <div className="relative flex  bg-gray-800 opacity-55">
                <div className="flex justify-start mx-12 items-center leading-8 w-full h-[300px]">
                    <h1 className=" font-bold text-5xl md:text-5xl text-white">Our Services</h1>
                    {/* <span><Link className='text-white' to='/'>Home</Link></span> */}
                </div>
            </div>
       </div>
      <ServiceComponent />
      <Stats />
      <GetInTouch />
    </>
  )
}

export default Services
